import { defineStore } from "pinia";
import Api from "@/api/Api";

const apiInstance = new Api();

export const useSenhaStore = defineStore("senhaStore", {
    state: () => ({
        senhas: [],
        nomeLoja: ''
    }),
    actions: {
        async listarSenhasPedido(lojaId) {
            try {
                const response = await apiInstance.getDataApi(`/api/listar-senhas-pedido/${lojaId}`);

                if (response.status && response.data?.senhas) {
                    this.senhas = response.data.senhas;

                    if (this.senhas.length > 0) {
                        this.nomeLoja = this.senhas[0].loja_nome;
                    }
                } else {
                    this.senhas = [];
                    this.nomeLoja = '';
                    console.warn("Erro ao listar senhas.");
                }

                return response;
            } catch (error) {
                console.error('Erro ao listar senhas:', error);
                this.senhas = [];
                this.nomeLoja = '';
            }
        },
    }
});